module.exports = __webpack_public_path__ + "img/mico-main.0c2758ac.webp";